<template>
  <div :class="{'animationComplete' : animationComplete}">
    <BackgroundFader class="blurable" ref="bgFader" :content="images" @complete="animationComplete = true;"/>
    <PageWrapper class="blurable">

      <InfoBlock :subTitle="gd[currentScenario].subTitle" :title="gd[currentScenario].title" :content="gd[currentScenario].steps[currentStep]"/>

      <Button btnContent="Replay animation" iconType="replay" @click="replay" class="replayButton reveal" />
      
      <Button class="scenarioNextButton" btnContent="Next step" iconType="arrow" @click="$router.push('step3')"/>
      <Button class="scenarioPreviousButton" iconType="arrow" @click="$router.push('step1')"/>
      <Button btnContent="Gallery" @click="openGallery" class="galleryButton" />
    
    </PageWrapper>

    <HotspotsWrapper class="blurable reveal">
      <Hotspot x="1180" y="100" @click="openModel('modelWindow1')"/>
    </HotspotsWrapper>

    <ModelWindow ref="modelWindow1" :image="require('@/assets/images/hotspots/Stationary_Area_Detection_(SAD).png')">
        <h1>Stationary Area Detection (SAD)</h1>
        <p>Saab’s SAD solution offers permanently installed surveillance of strategic sites and buildings.</p>
        <p>Designed for long-term use, it can accurately detect CBRN events.</p>
    </ModelWindow>

    <GalleryModal ref="galleryModal" :content="galleryImages"/>
  </div>
</template>


<script>
import PageWrapper from '@/components/PageWrapper';
import InfoBlock from '@/components/InfoBlock';
import AutoStep from '@/components/AutoStep';
import Button from '@/components/Button';
import ModelWindow from "@/components/ModelWindow";
import HotspotsWrapper from '@/components/HotspotsWrapper';
import Hotspot from '@/components/Hotspot';
import BackgroundFader from "@/components/BackgroundFader";
import gd from "@/assets/stores/globalDS.js";
import GalleryModal from '@/components/paul/GalleryModal';

export default {
  components: {
    PageWrapper,
    InfoBlock,
    AutoStep,
    Button,
    ModelWindow,
    HotspotsWrapper,
    Hotspot,
    BackgroundFader,
    GalleryModal
  },
  data() {
    return {
      gd: gd,
      animationComplete: false,
      images: [
        'chemical/2-1.jpg',
        'chemical/2-2.jpg',
        'chemical/2-3.jpg',
        'chemical/2-4.jpg',
        'chemical/2-5.jpg',
        'chemical/2-6.jpg',
        'chemical/2-7.jpg',
        'chemical/2-8.jpg',
        'chemical/2-9.jpg',
        'chemical/2-10.jpg'
      ],
      galleryImages: gd.gallery.chemical
    }
  },
  computed: {
    appPath() {
      return this.$router.currentRoute.fullPath.split("/");
    },
    currentStep() {
      return this.appPath[this.appPath.length - 1];
    },
    currentScenario() {
      return this.appPath[this.appPath.length - 2];
    }
  },
  methods: {
    replay() {
      this.animationComplete = false;
      this.$refs.bgFader.reset();
    },
    openModel: function(modelWindow) {
      this.$refs[modelWindow].openModel();
    },
    openGallery: function() {
      this.$refs.galleryModal.openModal();
    }
  }
}
</script>

